import { cursorPaginationFieldPolicy } from '../../../../../utils/policies/cursorPaginationFieldPolicy';
import type { TypePolicies } from '../../../../../utils/types/TypePolicies';

export const typePolicies: TypePolicies = {
  AccountUser: {
    fields: {
      directMemberships: cursorPaginationFieldPolicy([
        'page',
        ['first'],
        'membershipFilter',
        ['grantingResource', 'query'],
      ]),
      accountUserGroups: cursorPaginationFieldPolicy([
        'filter',
        ['name'],
        'page',
        ['first'],
      ]),
      userGroups: cursorPaginationFieldPolicy([
        'filter',
        ['name'],
        'page',
        ['first'],
      ]),
    },
  },
};
